const types = [
    { value: 1, name: '入库' },
    { value: 2, name: '申请领用' },
    { value: 3, name: '编辑' },
    { value: 4, name: '领用申请-撤销' },
    { value: 5, name: '领用申请-通过' },
    { value: 6, name: '领用申请-驳回' },
]

const getName = (state) => {
    const item = types.find(item => {
        return state == item.value;
    })

    return item.name;
}

export {
    types,
    getName
}